<template>
  <!-- Screenshots Section Start -->
  <section id="screenshot" class="screenshot padding-top-bottom">
    <div class="screenshot-decor">
      <div class="screenshot-circle1">
        <img
          :src='"../../assets/images/feature-circle-two-blue.png"'
          alt="feature-circle-two"
        />
      </div>
      <div class="screenshot-circle2">
        <img
          :src='"../../assets/images/feature-circle-blue.png"'
          alt="feature-circle"
        />
      </div>
      <div class="screenshot-circle3">
        <img
          :src='"../../assets/images/main-banner1-blue.png"'
          alt="feature-circle-three"
        />
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <div class="screenshot-contain">
            <img
              class="mobile-light-left"
              :src='"../../assets/images/light.png"'
              alt="light"
            />
            <img
              class="mob-mocup img-fluid"
              :src='"../../assets/images/mockups/screenshots/phone.png"'
              alt="screenshot-mob"
            />
            <img
              class="mobile-light-right"
              :src='"../../assets/images/light-right.png"'
              alt="light-right"
            />
            <swiper ref="mySwiper" :options="swiperOptions" :class="'swiper screenshot-carousel'">
              <swiper-slide>
                <div class="screenshot-item">
                  <img :src='"../../assets/images/mockups/screenshots/1.jpg"' class="img-fluid" alt="app"/>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="screenshot-item">
                  <img :src='"../../assets/images/mockups/screenshots/2.jpg"' class="img-fluid" alt="app"/>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="screenshot-item">
                  <img :src='"../../assets/images/mockups/screenshots/3.jpg"' class="img-fluid" alt="app"/>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="screenshot-item">
                  <img :src='"../../assets/images/mockups/screenshots/4.jpg"' class="img-fluid" alt="app"/>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="screenshot-item">
                  <img :src='"../../assets/images/mockups/screenshots/5.jpg"' class="img-fluid" alt="app"/>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="screenshot-item">
                  <img :src='"../../assets/images/mockups/screenshots/6.jpg"' class="img-fluid" alt="app"/>
                </div>
              </swiper-slide>

            </swiper>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Screenshots Section End -->
</template>
<script>
import {Swiper, SwiperSlide, directive} from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  name: 'Screenshots',
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  data () {
    return {
      swiperOptions: {
        slidesPerView: 5,
        loop: true,
        autoplay: {
          delay: 1500,
          stopOnLastSlide: false,
          disableOnInteraction: true
        },
        spaceBetween: 30,
        centeredSlides: true,
        breakpoints: {
          0: {slidesPerView: 2},
          767: {slidesPerView: 2},
          768: {slidesPerView: 3},
          992: {slidesPerView: 4},
          1200: {slidesPerView: 5}
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/offerPage/screenshots.vue